.footer {
  border-top: 1px solid var(--color-border);
  margin-top: auto;
}

.inner {
  width: min(1100px, calc(100% - 2rem));
  margin: 0 auto;
  padding: 1.25rem 0;
  color: var(--color-muted);
  font-size: 0.95rem;
}
